/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Features_Booking_LengthInputs */

const en_features_booking_length = /** @type {(inputs: Features_Booking_LengthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min · Strength Studio`)
};

const pl_features_booking_length = /** @type {(inputs: Features_Booking_LengthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.minutes} min · Studio Siła`)
};

/**
* | output |
* | --- |
* | "{minutes} min · Strength Studio" |
*
* @param {Features_Booking_LengthInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_booking_length = /** @type {((inputs: Features_Booking_LengthInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Booking_LengthInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_booking_length(inputs)
	return en_features_booking_length(inputs)
});